import { render, staticRenderFns } from "./BlockUserWarning.vue?vue&type=template&id=bfb6e3ec"
import script from "./BlockUserWarning.vue?vue&type=script&lang=js"
export * from "./BlockUserWarning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports